// Photo marquee (sections/photo-marquee.liquid): both rows stop while the mouse is over the section or focus is
// inside it (no pause button, client feedback 2026-10-09). With reduced motion the rows don't move on their own.
// Video cards play muted and looping while they're on screen, never with reduced motion or while the rows
// are stopped; the cover photo stays until a video actually plays.
if (!customElements.get('photo-marquee')) {
  customElements.define(
    'photo-marquee',
    class PhotoMarquee extends HTMLElement {
      connectedCallback() {
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = false;
        this.setUpPause();
        this.setUpVideos();
      }

      disconnectedCallback() {
        this.videoObserver?.disconnect();
        this.copyObserver?.disconnect();
      }

      setUpPause() {
        const section = this.closest('.photo-marquee') || this;
        let hovered = false;
        const refresh = () => {
          this.paused = hovered || section.matches(':focus-within');
          this.querySelectorAll('stay-marquee').forEach((marquee) => marquee.setPaused?.(this.paused));
          this.refreshVideos();
        };
        // A mouse only: a touch "hover" would stop the rows until the next tap elsewhere
        section.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          hovered = true;
          refresh();
        });
        section.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          hovered = false;
          refresh();
        });
        section.addEventListener('focusin', refresh);
        section.addEventListener('focusout', () => requestAnimationFrame(refresh));
      }

      setUpVideos() {
        this.visible = new Set();
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.visible.add(entry.target);
            else this.visible.delete(entry.target);
          });
          this.refreshVideos();
        });
        const watch = () => this.querySelectorAll('.photo-marquee__video').forEach((video) => this.videoObserver.observe(video));
        watch();
        // The marquee adds copies of each row after it measures; their videos need watching too
        this.copyObserver = new MutationObserver(watch);
        this.copyObserver.observe(this, { childList: true, subtree: true });
        this.reduced.addEventListener('change', () => this.refreshVideos());
      }

      refreshVideos() {
        const allowed = !this.reduced.matches && !this.paused;
        this.querySelectorAll('.photo-marquee__video').forEach((video) => {
          if (allowed && this.visible.has(video)) {
            video.muted = true;
            video
              .play()
              .then(() => video.classList.add('is-playing'))
              .catch(() => {});
          } else if (!video.paused) {
            video.pause();
          }
        });
      }
    }
  );
}
